import React, {useState} from 'react';
import {TbMathFunction} from "react-icons/tb";
import {TextContent} from "../routes/course/TextContent";

export function TaskSolution({show, solution}) {
    const [showSolution, setShowSolution] = useState(false);

    if(!show) return null;

    return (
        <div  className={" p-3 px-4 "} style={{backgroundColor:"#f0f4f8"}}>
            <div className={"d-flex align-items-center"}>
                <TbMathFunction className={"me-2"} size={24}/>
                <p className={"p-0 m-0  fw-bold"}>Løsningsforslag</p>
                <button className={"btn btn-dark mx-2"} onClick={() => setShowSolution(!showSolution)}>
                    {
                        showSolution ? "Skjul" : "Vis svaret"
                    }
                </button>
            </div>

            {
                showSolution ?
                    <TextContent value={solution}/>
                    :
                    null
            }

        </div>
    );


}